
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/implementation-plan",
      function () {
        return require("private-next-pages/events/implementation-plan.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/implementation-plan"])
      });
    }
  